angular.module('gym.contacts').controller('NewContactStylesCtrl', ["$scope", "$rootScope", "$state", "forms", "contact", function($scope, $rootScope, $state, forms, contact) {
  $scope.contact = contact;
  $scope.forms = forms.asJson();
  return $scope.cancel = function() {
    return $state.go('gym.contacts.new', {
      section: 'styles'
    });
  };
}]);
